const seo_words = {
  'community': {
    title: '海量免费插画/图标/UI设计素材,交互设计模板,线框原型设计规范- MasterGo资源社区',
    keywords: '设计规范,线框原型,图标设计,插画设计,UI设计,界面设计,交互设计,线框原型素材,图标设计素材,插画设计素材,UI设计素材,界面设计素材,交互设计素材,UI 资源',
    description:'MasterGo 社区，提供海量优质设计素材，设计系统，图标Icon，组件库，插画，样机，线框图，助力设计师和产品经理快速套用设计模板，提升设计效率。'
  },
  '/community/activity': {
    title: '资源广场-MasterGo 社区',
    keywords: '设计规范，线框原型，图标，插画，3D，UI设计，界面设计，交互设计',
    description:'MasterGo 社区，提供丰富的临摹教程、设计案例、设计课程，通过周期性练习，帮助你快速成长为大师。'
  },
  '/community/plugin': {
    title: '图标/原型设计插件,智能图表设计插件-MasterGo插件广场',
    keywords: '原型设计插件,图标插件,智能图表设计插件,Iconfont,文本插件,斜塔插件,取色插件,色彩插件,批量修改插件',
    description:'MasterGo 提供轻便丰富的插件系统，不仅可以让您在 MasterGo 上更高效完成大量重复性、复杂性的工作，还可以获得更多的设计能力加持，拓展创作边界，让设计更高效更灵动。'
  },

}

export function get_keywords(path) {
  if (path.indexOf('/community/activity') === 0) {
    return seo_words['/community/activity']
  }
  if (path.indexOf('/community/plugin') === 0) {
    return seo_words['/community/plugin']
  }
  return seo_words.community
}
